import app from '../app';

app.directive('cianAfDigitsOnly', () => {
    return {
        priority: 1,
        restrict: 'A',
        require: 'ngModel',
        link: (scope, element, attrs, ngModel) => {
            const replaceRegExp = (attrs.cianAfDigitsOnly === 'integer') ? /[^0-9]+/g : /[^\-\+\,\.0-9]+/g;
            const keepDigitsOnly = num => {
                num = String(num);
                const cleanNum = (num || '')
                    .replace(replaceRegExp, '');

                if (cleanNum !== num) {
                    ngModel.$setViewValue(cleanNum);
                    element.val(cleanNum);
                }

                return cleanNum;
            };

            ngModel.$parsers.unshift(keepDigitsOnly);
        },
    };
});
